/**
 * Trainova AI — TenantStatusBadge Component
 */

import { TenantStatus } from '../types';

interface TenantStatusBadgeProps {
  status: TenantStatus | string;
}

export function TenantStatusBadge({ status }: TenantStatusBadgeProps) {
  const norm = (status || 'ACTIVE').toUpperCase();
  const isSuspended = norm === 'SUSPENDED' || norm === 'ARCHIVED';

  return (
    <span
      className={`admin-status-badge ${
        isSuspended ? 'admin-status-badge--suspended' : 'admin-status-badge--active'
      }`}
    >
      <span className="admin-status-dot" />
      {norm === 'ACTIVE' ? 'Active' : norm === 'SUSPENDED' ? 'Suspended' : norm}
    </span>
  );
}
